export class ApplicantAccount {
  Id: string;
}
